import { useState } from "react";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import ContentCopy from "@mui/icons-material/ContentCopy";
import type { StreamOutputStatsSnapshot } from "../utils/streamOutputs";

export default function LlHlsLinks({ stats, fallback }: { stats?: StreamOutputStatsSnapshot; fallback: string }) {
  const [feedback, setFeedback] = useState("");
  const copy = async (value: string) => {
    try {
      if (navigator.clipboard?.writeText) await navigator.clipboard.writeText(value);
      else {
        const field = document.createElement("textarea");
        field.value = value; field.style.position = "fixed"; field.style.opacity = "0";
        document.body.appendChild(field); field.select();
        const copied = document.execCommand("copy"); field.remove();
        if (!copied) throw new Error("Copy failed");
      }
      setFeedback("Copied");
    } catch { setFeedback("Could not copy; select the URL to copy it"); }
  };
  return <Box component="span" sx={{ display: "inline-flex", flexWrap: "wrap", alignItems: "center", gap: 0.5 }}>
    <Typography component="span" variant="caption" sx={{ wordBreak: "break-all" }}>{stats?.playbackUrl || fallback}</Typography>
    {stats?.segmentFormat && <Typography component="span" variant="caption">{stats.segmentFormat === "mp4" ? "CMAF" : "MPEG-TS"} · {stats.publicationState}</Typography>}
    {stats?.metadataUrl && <Typography component="span" variant="caption" sx={{ wordBreak: "break-all" }}>Metadata: {stats.metadataUrl}</Typography>}
    {[["Copy playback URL", stats?.playbackUrl], ["Copy metadata URL", stats?.metadataUrl]].map(([label, value]) => value ?
      <Tooltip title={label} key={label}><IconButton size="small" aria-label={label} onClick={event => { event.stopPropagation(); void copy(value); }}><ContentCopy sx={{ fontSize: 14 }} /></IconButton></Tooltip> : null)}
    {feedback && <Typography component="span" variant="caption" role="status">{feedback}</Typography>}
  </Box>;
}
